import { render, staticRenderFns } from "./CompanyCarousel.vue?vue&type=template&id=80589c2e&scoped=true&"
import script from "./CompanyCarousel.vue?vue&type=script&lang=ts&"
export * from "./CompanyCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyCarousel.vue?vue&type=style&index=0&id=80589c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80589c2e",
  null
  
)

/* custom blocks */
import block0 from "./CompanyCarousel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports